// Approved Zoe/Nova cards, using Hale’s native Impulse cart event and locale routes.
class HaleCrosssell extends HTMLElement {
  connectedCallback() {
    if (this.bound) { this.observer?.observe(this); return; }
    this.bound = true;
    this.addEventListener('change', e => {
      const card = e.target.closest('.hale-xs-up-card');
      if (card) this.sync(card);
    });
    this.addEventListener('click', e => this.click(e));
    this.addEventListener('scroll', () => this.nav(), true);
    this.observer = new ResizeObserver(() => this.nav());
    this.observer.observe(this);
    this.load();
  }
  disconnectedCallback() { this.observer?.disconnect(); }
  async load() {
    for (const url of [this.dataset.fallback]) {
      try {
        const response = await fetch(url);
        if (!response.ok) continue;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = doc.querySelector('[data-hale-xs-results]');
        if (!results?.querySelector('.hale-xs-up-card')) continue;
        if (!this.isConnected) return;
        this.querySelector('.hale-xs-up-mount').innerHTML = results.innerHTML;
        this.querySelectorAll('.hale-xs-up-card').forEach(c => this.sync(c));
        this.hidden = false;
        this.nav();
        return;
      } catch (_) { /* Continue to the next recommendation source. */ }
    }
  }
  sync(card) {
    const variants = JSON.parse(card.querySelector('.hale-xs-up-vjson').textContent);
    const options = [...card.querySelectorAll('select')].map(s => s.value);
    const variant = options.length ? variants.find(v => v.opts.every((o,i) => o === options[i])) : variants.find(v => String(v.id) === card.querySelector('.hale-xs-up-add').dataset.variantId) || variants.find(v => v.available) || variants[0];
    const button = card.querySelector('.hale-xs-up-add');
    button.disabled = !variant?.available;
    button.dataset.variantId = variant?.id || '';
    button.querySelector('.hale-xs-up-add-label').textContent = variant?.available ? this.dataset.add : this.dataset.sold;
    const plus = button.querySelector('.hale-xs-up-plus');
    if (plus) plus.hidden = !variant?.available;
    if (!variant) return;
    card.querySelector('.hale-xs-up-now').textContent = variant.price;
    let compare = card.querySelector('.hale-xs-up-was');
    if (!compare) { compare = document.createElement('s'); compare.className = 'hale-xs-up-was'; card.querySelector('.hale-xs-up-price').append(compare); }
    compare.textContent = variant.compare;
    compare.hidden = !variant.sale;
    if (variant.img) card.querySelector('img').src = variant.img;
  }
  nav() {
    const track = this.querySelector('.hale-xs-up-track');
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth;
    this.querySelector('.hale-xs-up-prev').hidden = max < 4 || track.scrollLeft <= 2;
    this.querySelector('.hale-xs-up-next').hidden = max < 4 || track.scrollLeft >= max - 2;
  }
  async click(event) {
    const arrow = event.target.closest('.hale-xs-up-nav');
    if (arrow) {
      const track = this.querySelector('.hale-xs-up-track');
      const width = track.querySelector('.hale-xs-up-card').getBoundingClientRect().width + 12;
      track.scrollBy({left: arrow.classList.contains('hale-xs-up-prev') ? -width : width, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      return;
    }
    const button = event.target.closest('.hale-xs-up-add');
    if (!button || button.disabled) return;
    button.disabled = true;
    const error = this.querySelector('.hale-xs-error');
    error.textContent = '';
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:button.dataset.variantId,quantity:1}]})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
      if (document.querySelector('#CartDrawer')) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{product:result,addToCartBtn:button}}));
      } else location.assign(root + 'cart');
    } catch (e) { error.textContent = e.message || this.dataset.error; }
    finally { button.disabled = false; }
  }
}
if (!customElements.get('hale-crosssell')) customElements.define('hale-crosssell', HaleCrosssell);
